<template>
  <div class="app-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>{{ $t('check.search_title') }}</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="道路车辆检验（测）报告" name="on-road">
          <on-road ref="onRoad" />
        </el-tab-pane>
        <el-tab-pane label="非道路车辆检验（测）报告" name="off-road">
          <off-road ref="offRoad" />
        </el-tab-pane>
        <el-tab-pane label="安全检验报告" name="security">
          <security ref="security" />
        </el-tab-pane>
      </el-tabs>

    </el-card>
  </div>
</template>

<script>
import waves from '@/directive/waves' // waves directive
import permission from '@/directive/permission'
import OnRoad from '@/views/approver/Components/OnRoad'
import OffRoad from '@/views/approver/Components/OffRoad'
import Security from '@/views/approver/Components/Security'
export default {
  name: 'ApproverIndex',
  components: { OnRoad, OffRoad, Security },
  directives: { waves, permission },
  data() {
    return {
      activeName: 'on-road'
    }
  },
  created() {},
  methods: {
    handleClick(tab, event) {
      if (tab.name === 'on-road') {
        this.$refs.onRoad.handleTable()
      } else if (tab.name === 'off-road') {
        this.$refs.offRoad.handleTable()
      } else if (tab.name === 'security') {
        this.$refs.security.handleTable()
      }
    }
  }
}
</script>

<style scoped>

</style>
